import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuoteMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 11.7817C5.06112 8.65535 6.02255 2.7889 6.26786 0L14 8.31791C7.74769 13.3022 0 11.7817 0 11.7817Z",
		fill: "#221C32"
	})
});
export default SvgQuoteMark;
